<template>
  <Card class="page-teamDoctor">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1; display: flex">
        <!-- <el-input
          v-model="name"
          placeholder="请输入成员名称"
          style="max-width: 350px"
          @keyup.enter.native="getQueryList"
        />
        <el-button
          type="primary"
          round
          style="margin-left: 30px"
          @click="getQueryList"
          >搜索</el-button
        > -->
      </div>
      <div>
        <el-button type="primary" round @click="add">新增团队成员</el-button>
      </div>
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-popover style="margin:0 5px;" @show="useqrcode(row)" placement="bottom-start" trigger="hover">
          <canvas :id="'canvas' + row.id"></canvas>
          <el-button type="text" size="mini" slot="reference">二维码</el-button>
        </el-popover>
        <el-button type="text" style="margin-right: 10px" @click="showTeamModal(row)">编辑</el-button>
        <el-popconfirm title="确定删除该成员吗？" @confirm="remove(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <caring-contact-modal
      ref="caringContactModal"
      title="新增成员"
      @on-submit="onContactSubmit"
      @on-addressBook="addAddress"
      @on-addressDept="addDept"
    />
    <Modal v-model="show" :mask-closable="false" width="550" @on-cancel="cancel">
      <div slot="header" style="text-align: center">
        <span>{{ edit ? "编辑" : "新增" }}团队成员</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :rules="rule"
        :label-width="150"
        label-position="right"
        style="margin-left: -40px; margin-right: 40px"
      >
        <FormItem v-if="!edit" label="成员" prop="list">
          <Select v-model="cur.list" multiple>
            <Option v-for="u in userlist" :key="u.id" :value="u.id">{{
              u.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="角色分配" prop="role">
          <Select v-model="cur.role" multiple>
            <Option v-for="r in rolelist" :key="r.role_id" :value="r.role_id">{{
              r.show_name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否隐藏" prop="is_hide" required>
          <Select v-model="cur.is_hide">
            <Option :key="0" :value="0">否</Option>
            <Option :key="1" :value="1">是</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancel">取消</el-button>
        <el-button type="primary" round :loading="modalLoading" @click="save"
          >保存</el-button
        >
      </div>
    </Modal>
    <Modal v-model="addressShow" :mask-closable="false" width="550" @on-cancel="cancelAddress">
      <div slot="header" style="text-align: center">
        <span>新增通讯录成员</span>
      </div>
      <Form
        ref="form1"
        :model="curAddress"
        :rules="ruleAddress"
        :label-width="150"
        label-position="right"
        style="margin-left: -40px; margin-right: 40px"
      >
        <FormItem label="成员名称" prop="name">
          <Input
            v-model.trim="curAddress.name"
            :maxlength="30"
            placeholder="请输入成员名称"
          />
        </FormItem>
        <FormItem label="成员工号" prop="employee_id">
          <Input
            v-model.trim="curAddress.employee_id"
            :maxlength="30"
            placeholder="请输入成员工号"
          />
        </FormItem>
        <FormItem label="密码" prop="password">
          <Input
            v-model.trim="curAddress.password"
            :maxlength="30"
            type="password"
            placeholder="请输入成员密码"
          />
        </FormItem>
        <FormItem label="手机号" prop="phone">
          <Input
            v-model.trim="curAddress.phone"
            :maxlength="30"
            placeholder="请输入成员手机"
          />
        </FormItem>
        <FormItem label="科室" prop="dept_id">
          <Select
            v-model="curAddress.dept_id"
            filterable
            placeholder="请选择科室"
          >
            <Option v-for="a in addressDept" :key="a.id" :value="a.id">{{
              a.dept_name
            }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelAddress">取消</el-button>
        <el-button type="primary" round :loading="addressModalLoading" @click="saveAddress">保存</el-button>
      </div>
    </Modal>
    <Modal v-model="deptShow" :mask-closable="false" width="550" @on-cancel="cancelDept">
      <div slot="header" style="text-align: center">
        <span>新增通讯录科室</span>
      </div>
      <Form
        ref="form2"
        :model="curDept"
        :rules="ruleDept"
        :label-width="150"
        label-position="right"
        style="margin-left: -40px; margin-right: 40px"
      >
        <FormItem label="科室编码" prop="dept_code">
          <Input
            v-model.trim="curDept.dept_code"
            :maxlength="20"
            placeholder="请输入科室编码"
          />
        </FormItem>
        <FormItem label="科室名称" prop="dept_name">
          <Input
            v-model.trim="curDept.dept_name"
            :maxlength="50"
            placeholder="请输入科室名称"
          />
        </FormItem>
        <FormItem label="院区" prop="branch">
          <Input
            v-model.trim="curDept.branch"
            :maxlength="50"
            placeholder="请输入院区名称"
          />
        </FormItem>
        <FormItem label="简介" prop="desc">
          <Input
            v-model.trim="curDept.desc"
            :maxlength="50"
            placeholder="请输入科室简介"
          />
        </FormItem>
        <FormItem label="联系电话" prop="phone">
          <Input
            v-model.trim="curDept.phone"
            :maxlength="50"
            placeholder="请输入联系电话"
          />
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input
            v-model.trim="curDept.address"
            :maxlength="50"
            placeholder="请输入科室地址"
          />
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelDept">取消</el-button>
        <el-button type="primary" round :loading="deptModalLoading" @click="saveDept">保存</el-button>
      </div>
    </Modal>
  </Card>
</template>
<script>
import QRCode from 'qrcode';
import md5 from 'md5';
import storage from 'store';
import pswStrength from '../../utils/pwd';
import {
  getTeamDoctorListApi,
  addTeamDoctorApi,
  getUserDeptListApi,
  addTeamDoctorUserApi,
  updateTeamDoctorApi,
  removeTeamDoctorApi,
  updateAddressDeptApi,
} from '../../api/manage';
import { fetchAddressBookListApi } from '../../utils/addressBook';
import { getRoleListApi } from '../../api/user';
import { ADDRESS_BOOK } from '../../utils/env';
import caringContactModal from '../../components/caring-contact-modal.vue';

export default {
  components: {
    caringContactModal,
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const rulePass = (rule, value, callback) => {
      const level = pswStrength.getPasswordLevel(value);
      if (level === 'EASY') {
        callback(new Error('密码强度过低'));
      }
      callback();
    };
    return {
      name: '',
      columns: [
        {
          title: 'ID',
          align: 'center',
          key: 'id',
        },
        {
          align: 'center',
          title: '名称',
          key: 'name',
        },
        {
          title: '角色',
          align: 'center',
          key: 'team_roles',
          render: (h, props) => h(
            'span',
            props.row.team_roles
              ? props.row.team_roles.map((r) => r.show_name).join(',')
              : '',
          ),
        },
        {
          title: '手机号',
          align: 'center',
          key: 'phone',
        },
        {
          title: '工号',
          align: 'center',
          key: 'employee_id',
        },
        {
          title: '科室名称',
          align: 'center',
          key: 'dept_name',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          width: 220,
        },
      ],
      dataSource: [],
      loading: false,
      show: false,
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      show: false,
      cur: {
        role: [],
        list: [],
        is_hide: 0
      },
      rule: this.edit
        ? {
          role: [
            {
              required: true,
              type: 'array',
              message: '请选择角色',
              trigger: 'change',
            },
          ],
        }
        : {
          list: [
            {
              required: true,
              type: 'array',
              message: '请选择成员',
              trigger: 'change',
            },
          ],
          role: [
            {
              required: true,
              type: 'array',
              message: '请选择角色',
              trigger: 'change',
            },
          ],
        },
      curList: [],
      rolelist: [],
      modalLoading: false,
      addressShow: false,
      addressModalLoading: false,
      deptShow: false,
      deptModalLoading: false,
      curAddress: {
        dept_id: '',
        name: '',
        employee_id: '',
        password: '',
        phone: '',
      },
      ruleAddress: {
        name: [
          { required: true, message: '请输入成员名称', trigger: 'blur' },
          { required: true, message: '请输入成员名称', trigger: 'change' },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入由中英文、数字以及下划线组成的成员名称', trigger: 'blur',
          },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入由中英文、数字以及下划线组成的成员名称', trigger: 'change',
          },
        ],
        password: [
          {
            required: true,
            type: 'string',
            message: '请输入成员密码',
            trigger: 'blur',
          },
          {
            required: true,
            type: 'string',
            message: '请输入成员密码',
            trigger: 'change',
          },
          { validator: rulePass, trigger: 'blur' },
          { validator: rulePass, trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入成员手机', trigger: 'blur' },
          { required: true, message: '请输入成员手机', trigger: 'change' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'change',
          },
        ],
        dept_id: [
          {
            required: true,
            type: 'number',
            message: '请选择科室',
            trigger: 'change',
          },
        ],
        employee_id: [
          {
            required: true,
            message: '请填写成员工号',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写成员工号',
            trigger: 'change',
          },
          {
            pattern: /^\w+$/,
            message: '请输入由数字、字母以及下划线组成的成员工号',
            trigger: 'blur',
          },
          {
            pattern: /^\w+$/,
            message: '请输入由数字、字母以及下划线组成的成员工号',
            trigger: 'change',
          },
        ],
      },
      addressDept: [],
      edit: false,
      curDept: {},
      ruleDept: {
        dept_name: [
          { required: true, message: '请输入科室名称', trigger: 'blur' },
          { required: true, message: '请输入科室名称', trigger: 'change' },
        ],
        dept_code: [
          { required: true, message: '请输入科室编码', trigger: 'blur' },
          { required: true, message: '请输入科室编码', trigger: 'change' },
        ],
      },
      userlist: []
    };
  },
  created() {
    this.getList();
    this.getRoleList();
    this.getUser();
    fetchAddressBookListApi(false);
  },
  methods: {
    useqrcode(row) {
      const canvas = document.getElementById(`canvas${row.id}`);
      QRCode.toCanvas(canvas, `${row.url}?id=${row.id}`, (error) => {
        if (error) console.error(error);
      });
    },
    getUser() {
      const addressBook = storage.get(ADDRESS_BOOK + this.$store.state.user.user.id + this.$store.state.tenant.tenant);
      let userlist = [];
      addressBook.forEach((item) => {
        userlist = userlist.concat(item.users);
      });
      this.userlist = userlist;
    },
    onCurrentChange(current) {
      this.page = current;
      this.getList();
    },
    onSizeChange(size) {
      this.size = size;
      this.getList();
    },
    getQueryList() {
      this.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      const { name, page, size } = this;
      getTeamDoctorListApi({
        headers: {
          team_id: this.row.id,
          tenant: this.$store.state.tenant.tenant,
        },
        params: {
          name,
          page,
          size,
        },
      }).then((res) => {
        this.loading = false;
        if (res.code === 0) {
          this.dataSource = res.data;
          this.total = res['x-total-count'] || res.data.length;
          if (this.total && !this.dataSource.length && this.page > 1) {
            this.page -= 1;
            this.getList();
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getRoleList() {
      getRoleListApi({ role: 48 }).then((res) => {
        if (res.code === 0) {
          this.rolelist = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getUserDeptList() {
      getUserDeptListApi().then((res) => {
        if (res.code === 0) {
          this.addressDept = res.data || [];
          if (this.addressDept.length) {
            this.curAddress.dept_id = res.data[0].id;
            this.curAddress.dept_name = res.data[0].dept_name;
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    add() {
      this.$refs.caringContactModal.show([]);
      fetchAddressBookListApi(false);
      this.getUser();
    },
    onContactSubmit(list) {
      this.$refs.caringContactModal.hide();
      this.cur.list = list.map((l) => l.id);
      this.show = true;
      this.edit = false;
      this.getRoleList();
    },
    showTeamModal(row) {
      console.log(row)
      this.edit = true;
      this.cur.list = [row.id - 0];
      this.cur.role = row.team_roles.map((t) => t.id);
      this.cur.is_hide = row.is_hide;
      this.show = true;
    },
    remove(row) {
      removeTeamDoctorApi({ user_id: row.id, team_id: this.row.id }).then(
        (res) => {
          if (res.code === 0) {
            this.$Message.success('删除成功');
            this.getList();
          } else {
            this.$Message.error(res.message);
          }
        },
      );
    },
    cancel() {
      this.$refs.form.resetFields();
      this.show = false;
      this.modalLoading = false;
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modalLoading = true;
          const {
            name: team_name,
            id: team_id,
            institution_id,
            institution_name,
            dept_id,
            dept_name,
          } = this.row;
          if (this.edit) {
            const config = {
              doctor: this.cur.list
                .map((l) => this.dataSource.find((u) => u.id == l))
                .map((u) => ({
                  user_id: u.id,
                  username: u.username,
                  name: u.name,
                  phone: u.phone,
                }))[0],
              roles_list: this.cur.role,
              team_id,
              team_name,
              institution_id,
              institution_name,
              dept_id,
              dept_name,
              is_hide: this.cur.is_hide
            };
            updateTeamDoctorApi(config)
              .then((res) => {
                this.modalLoading = false;
                if (res.code === 0) {
                  this.$Message.success('保存成功');
                  this.getList();
                  this.cancel();
                } else {
                  this.$Message.error(res.message);
                }
              })
              .catch(() => {
                this.modalLoading = false;
              });
          } else {
            const config = {
              doctors: this.cur.list
                .map((l) => this.userlist.find((u) => u.id == l))
                .filter((u) => !this.dataSource.find((d) => d.id == u.id))
                .map((u) => ({
                  user_id: u.id,
                  username: u.username,
                  name: u.name,
                  phone: u.phone,
                })),
              roles_list: this.cur.role,
              team_id,
              team_name,
              institution_id,
              institution_name,
              dept_id,
              dept_name,
              is_hide: this.cur.is_hide
            };
            addTeamDoctorApi(config)
              .then((res) => {
                this.modalLoading = false;
                if (res.code === 0) {
                  this.$Message.success('保存成功');
                  this.getList();
                  this.cancel();
                } else {
                  this.$Message.error(res.message);
                }
              })
              .catch(() => {
                this.modalLoading = false;
              });
          }
        }
      });
    },
    addAddress() {
      this.addressShow = true;
      this.getUserDeptList();
    },
    addDept() {
      this.deptShow = true;
    },
    cancelAddress() {
      this.$refs.form1.resetFields();
      this.addressShow = false;
      this.addressModalLoading = false;
    },
    cancelDept() {
      this.$refs.form2.resetFields();
      this.curDept = {};
      this.deptShow = false;
      this.deptModalLoading = false;
    },
    saveAddress() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.addressModalLoading = true;
          const d = {
            user_pwd: md5(this.curAddress.password),
            name: this.curAddress.name,
            phone: this.curAddress.phone,
            dept_id: this.curAddress.dept_id,
            dept_code: this.addressDept.find(
              (d) => d.id == this.curAddress.dept_id,
            ).dept_code,
            dept_name: this.addressDept.find(
              (d) => d.id == this.curAddress.dept_id,
            ).dept_name,
            employee_id: this.curAddress.employee_id,
          };
          addTeamDoctorUserApi(d).then((res) => {
            this.addressModalLoading = false;
            if (res.code === 0) {
              fetchAddressBookListApi(false).then(() => {
                this.$refs.caringContactModal.getDataByStorage();
                this.getUser();
              });
              this.cancelAddress();
              this.$Message.success('保存成功');
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    saveDept() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.deptModalLoading = true;
          const d = {
            parent_id: 1,
            parent_dept_code: 1,
            dept_name: this.curDept.dept_name,
            dept_code: this.curDept.dept_code,
          };
          updateAddressDeptApi(d).then((res) => {
            this.deptModalLoading = false;
            if (res.code === 0) {
              fetchAddressBookListApi(false).then(() => {
                this.$refs.caringContactModal.getDataByStorage();
                this.getUser();
              });
              this.cancelDept();
              this.$Message.success('保存成功');
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less">
.page-teamDoctor {
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
.page-teamDoctorModal {
  .ivu-card-body {
    padding: 0;
  }
}
</style>
